var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'loading-droppo',
        _vm.finish ? 'loading-droppo--finish' : ''
       ]},[_c('div',{class:[
      'loading-droppo__hat',
      _vm.finish ? 'show-hat' : ''
    ]},[_vm._m(0)]),(!_vm.finish)?_c('div',{staticClass:"loading-droppo__balls-wrapper"},_vm._l((12),function(n){return _c('div',{key:("" + n),staticClass:"loading-droppo__ball-bar",style:({
              transform: ("rotateZ(" + (n * 30) + "deg)"),
              'animation-delay': ((n === 0 ? 0 : 1/12 * n) + "s")
           })},[_c('div',{staticClass:"loading-droppo__ball"})])}),0):_vm._e(),_c('div',{staticClass:"loading-droppo__big-o"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hat-wrapper"},[_c('i',{staticClass:"fas fa-check"})])}]

export { render, staticRenderFns }